import {
  createFileRoute,
  Link,
  Outlet,
  redirect,
  useLocation,
} from '@tanstack/react-router';

import { SearchBar } from '@components/SearchBar';
import { Sidebar } from '@components/Sidebar';
import { ThemeToggle } from '@components/ThemeToggle';
import { ScrollArea } from '@components/ui/scroll-area';
import { Tabs } from '@components/ui/tabs';

export const Route = createFileRoute('/_layout')({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      context.queryClient.clear();
      throw redirect({
        to: '/',
        search: { redirect: location.pathname },
      });
    }
  },
  component: PrivateLayout,
});

function PrivateLayout() {
  return (
    <div className="bg-background grid min-h-screen grid-cols-[auto_1fr]">
      <Sidebar />

      <ScrollArea className="h-dvh">
        <main className="min-h-dvh">
          <div className="relative px-1 py-3 md:px-5 md:py-6 2xl:p-6">
            <div className="mb-5 flex justify-between">
              <SearchBar />
              <ThemeToggle />
            </div>
            <NavigateTabs />
            <Outlet />
          </div>
        </main>
      </ScrollArea>
    </div>
  );
}

export function NavigateTabs() {
  const { pathname } = useLocation();

  if (pathname !== '/service-requests' && pathname !== '/interventions') {
    return null;
  }

  return (
    <Tabs.Container className="absolute z-10" defaultValue={pathname}>
      <Tabs.List showIndicator variant="horizontal">
        <Tabs.Trigger
          asChild
          className="px-4 font-medium"
          value="/service-requests"
          variant="horizontal"
        >
          <Link
            disabled={pathname === '/service-requests'}
            to="/service-requests"
          >
            SR
          </Link>
        </Tabs.Trigger>
        <Tabs.Trigger
          asChild
          className="px-4 font-medium"
          value="/interventions"
          variant="horizontal"
        >
          <Link disabled={pathname === '/interventions'} to="/interventions">
            Interventions
          </Link>
        </Tabs.Trigger>
      </Tabs.List>
    </Tabs.Container>
  );
}
